import { type ReactNode } from 'react';

export interface Content<T> {
  items: T[];
  renders: Array<(item: T) => ReactNode>;
  onClick?: (item: T) => void;
}

interface Props<T> {
  content: Content<T>;
}

export const ListContent = <T,>({content}: Props<T>): JSX.Element => {
  if (!Array.isArray(content.items)) {
    return <></>;
  }

  return (
    <>
      {content.items.map((item, row) => (  
        <tr
          key={`table-row-${row}`}
          className={`h-16 ${content.onClick && 'cursor-pointer hover:bg-slate-50'}`}
          onClick={() => content.onClick?.(item)}
        >
          {content.renders.map((render, col) => (
            <td key={`table-cell-${row}-${col}`} className="px-1">
              {render(item)}
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
